import React from 'react';

type Props = {
  status?: string;
  style?: React.CSSProperties;
};

const CarvalooStatusBadge: React.FC<Props> = ({ status, style }) => {
  if (!status) return null;
  return (
    <span
      data-testid="CarvalooStatusBadge"
      style={{
        display: 'inline-block',
        padding: '2px 8px',
        background: '#f0f0f0',
        border: '1px solid #d9d9d9',
        borderRadius: 4,
        fontSize: 12,
        color: '#595959',
        lineHeight: '18px',
        ...style,
      }}
    >
      {status}
    </span>
  );
};

export default CarvalooStatusBadge;
